var map = {
	"./about-us.webp": 3228,
	"./careers.webp": 4979,
	"./certifications_compliances.webp": 2264,
	"./close-up-graduation-diploma.webp": 4882,
	"./cloud_services.webp": 9458,
	"./colocation_services.webp": 3786,
	"./dedicated_servers.webp": 22,
	"./engineers_service.webp": 8982,
	"./it_consultation.webp": 8555,
	"./partners.webp": 4083,
	"./pri.webp": 3217,
	"./rental_hardware.webp": 883,
	"./security.webp": 7354,
	"./software_development.webp": 2623,
	"./testimonials.webp": 3676,
	"./vps_services.webp": 6056
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8642;